import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import type { StageBucket } from "@/model/interface/DashboardSummary";

const formatCurrency = (value: number): string =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

const PipelineCard: React.FC<{ stages: StageBucket[]; pipelineValue: number; openCount: number }> = ({
  stages,
  pipelineValue,
  openCount,
}) => {
  const navigate = useNavigate();

  const maxStage = Math.max(1, ...stages.map((stage) => stage.count));

  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Pipeline</h2>
        <Button variant="link" size="sm" className="h-auto px-0 text-xs" onClick={() => navigate("/deals")}>
          View all
        </Button>
      </div>
      <div>
        <p className="text-xl font-semibold tabular-nums">{formatCurrency(pipelineValue)}</p>
        <p className="text-xs text-muted-foreground tabular-nums">{openCount} open deals</p>
      </div>
      {stages.length === 0 ? (
        <p className="py-2 text-sm text-muted-foreground">No deals yet.</p>
      ) : (
        <div className="mt-1 flex flex-col gap-2.5">
          {stages.map((stage) => (
            <div key={stage.stage}>
              <div className="mb-1 flex items-center justify-between gap-2 text-xs">
                <span className="truncate">{stage.stage}</span>
                <span className="text-muted-foreground tabular-nums">{stage.count}</span>
              </div>
              <div className="h-1.5 rounded-full bg-muted">
                <div
                  className="h-1.5 rounded-full bg-muted-foreground/50"
                  style={{ width: `${(stage.count / maxStage) * 100}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default PipelineCard;
